module.exports = __webpack_public_path__ + "static/media/spartacus_wordmark.6c80d25a.svg";